import { type FC } from 'react'
import cn from 'classnames'
import styles from './loader.module.css'

export interface LoaderProps {
  width?: string
  height?: string
  className?: string
}

export const Loader: FC<LoaderProps> = ({ width = '2rem', height = '2rem', className }) => {
  return (
    <div
      className={cn(styles['lds-ellipsis'], className)}
      style={{
        width,
        height,
      }}
    >
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}
